import { createActionTypes } from 'utils/action/actionTypes';

export const CHARGER_STATUS = createActionTypes('CHARGER_STATUS');
export const FETCH_CHARGER_STATUS_WIDGETS = createActionTypes('FETCH_CHARGER_STATUS_WIDGETS');
export const CHARGER_STATUS_DOWNLOAD = createActionTypes('CHARGER_STATUS_DOWNLOAD');
